<app-sidebar (toggleEmitter)="toggle()"></app-sidebar>

<section>
	<div id="wrapper" class="active">
		<div class="fakeLoader"></div>

		<!-- Sidebar Navigation -->

		<div id="page-wrapper">
			<div class="row page-titles">
				<div class="col-md-5 align-self-center">
					<h3 class="text-themecolor">Change Password</h3>
				</div>
				<div class="col-md-7 align-self-center">
					<!-- <ol class="breadcrumb">
						<li class="breadcrumb-item" title="Dashboard"><a [routerLink]="['/dashboard']">Dashboard</a></li>
						<li class="breadcrumb-item active">Change Password</li>
					</ol> -->
				</div>
			</div>
			<div class="container-fluid">
				<!-- /row -->
				<div class="row">
					<div class="col-md-6 col-md-offset-3 mrg-top-25 mrg-bot-25 ">
						<!-- General Information -->
						<div class="card">
							
							<form [formGroup]="changeForm" (ngSubmit)="onSubmit()">

								<div class="card-body padd-bot-10 padd-top-0">
									<div class="col-lg-12">
										<div class="row filter-row">
											<!-- General Information -->

											<div class="row12">
												
												<div class="col-sm-12 mrg-top-15 ">
													<div class="row">
														<div class="col-sm-12 mrg-bot-15 mrg-top-15">
															<label for="">Current password</label>
															<input type="password" formControlName="currentpwd"
																class="form-control"
																placeholder="Enter Current password">
														</div>
														<div class="col-sm-12 mrg-bot-15">
															<label for="">New Password</label>
															<input type="password" formControlName="newpassword"
																class="form-control" placeholder="Enter New Password">
																<small class="text-danger">
																	Password must contain alteast 6 digit.
																	<!-- 2. Password must contain atleast 1 special character. -->
																</small>
														</div>
														<div class="col-sm-12 mrg-bot-15">
															<label for="">Confirm Password</label>
															<input type="password" formControlName="confirmpassword"
																class="form-control" placeholder="Confirm Password">
														</div>
													</div>
												</div>
												<div class="col-sm-4"></div>
											</div>
											<div class="row12">
												
												<div class="col-md-12 mrg-bot-15">
													<button type="submit" [disabled]="!changeForm?.valid"
														class="btn btn-primary mrg-bot-15 ">Save Change Password</button>
												</div>
											</div>

										</div>

									</div>

								</div>
							</form>
						</div>

					</div>
				</div>
			</div>
		</div>


	</div>
</section>
<app-footer></app-footer>